/** Calendly booking; primary color matches brand green */
export const CALENDLY_URL = 'https://calendly.com/saif-cure8studios?primary_color=2d6a4f';
